import React, { useState } from "react";
import PropTypes from "prop-types";
import QuestionContainer from "../../../shared/QuestionContainer";

const stripCyuPrefix = (html = "") => {
  if (!html || typeof document === "undefined") return html.trim();

  const container = document.createElement("div");
  container.innerHTML = html;

  const walker = document.createTreeWalker(
    container,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );

  let textNode = walker.nextNode();
  while (textNode && !textNode.nodeValue.trim()) {
    textNode = walker.nextNode();
  }

  if (textNode) {
    textNode.nodeValue = textNode.nodeValue.replace(
      /^\s*Check Your Understanding:\s*/i,
      ""
    );
  }

  return container.innerHTML.trim();
};

const answerCorrectness = (answer = {}) => {
  if (typeof answer.correct === "boolean") return answer.correct;
  if (typeof answer["correct?"] === "boolean") return answer["correct?"];
  return false;
};

const CyuQuestionElement = (props) => {
  const [result, setResult] = useState(null);
  const { question, answers, titleColor, title } = props;

  const checkAnswer = (answer) => {
    setResult({
      answerId: answer.id,
      correct: answer.correct,
    });
  };

  return (
    <QuestionContainer color={titleColor} title={title}>
      <div className="cyu-question-card">
        <Question html={question} />
        <div className="cyu-answer-list">
          <form>
            {answers.map((answer) => {
              const correct = answerCorrectness(answer);

              return (
                <Answer
                  checkAnswer={checkAnswer}
                  id={answer.id}
                  key={answer.id}
                  html={answer.answer}
                  correct={correct}
                  result={result}
                />
              );
            })}
          </form>
        </div>
      </div>
    </QuestionContainer>
  );
};

const Question = (props) => {
  const html = stripCyuPrefix(props.html);

  return (
    <div className="cyu-question-prompt">
      <h2 className="cyu-question-label">
        <span className="cyu-question-icon" aria-hidden="true">
          <i className="bx bxs-help-circle" />
        </span>
        <span className="cyu-question-label-text">Check Your Understanding</span>
      </h2>

      <div
        className="cyu-question-text"
        role="heading"
        aria-level="3"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
};

const Answer = (props) => {
  const { html, id, checkAnswer, correct, result } = props;
  const qId = "question" + id;
  const isSelected = result && result.answerId === id;
  const selectedIsCorrect = isSelected && result.correct === true;

  return (
    <div className="cyu-answer">
      <input
        id={qId}
        type="radio"
        name="answer"
        className={
          isSelected
            ? selectedIsCorrect
              ? "btn-form checked-success radius cyu-answer-input"
              : "btn-form checked-danger radius cyu-answer-input"
            : "btn-form checked-secondary radius cyu-answer-input"
        }
        value={id}
        onChange={() => checkAnswer({ id, correct })}
      />

      <label
        className="expand drop-shadow cyu-answer-option"
        htmlFor={qId}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
};

CyuQuestionElement.propTypes = {
  question: PropTypes.string,
  answers: PropTypes.array,
};
export default CyuQuestionElement;
